var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TimePicker } from './TimePicker';
import { defaultRangeProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { WrongFilled } from '@feb-team/legao-icons-react';
var RangeTimePicker = /** @class */ (function (_super) {
    __extends(RangeTimePicker, _super);
    function RangeTimePicker(props) {
        var _this = _super.call(this, props) || this;
        /** 确定 */
        _this.timeItemChange = function (e, time, type) {
            var preValueOne = _this.timePickerOne.state.prevValue;
            var preValueTwo = _this.timePickerOne.state.prevValue;
            if (_this.props.onBeforeChange([preValueOne, preValueTwo], e)) {
                var nextRangeStr = _this.state.selectedRangeStr;
                nextRangeStr[type] = time;
                if (_this.props.value !== undefined) {
                    _this.setState({
                        selectedRangeStr: [
                            _this.timePickerOne.state.prevValue,
                            _this.timePickerTwo.state.prevValue,
                        ],
                    });
                }
                else {
                    _this.setState({
                        selectedRangeStr: nextRangeStr,
                    });
                }
                _this.setState({
                    allowClear: false,
                });
                _this.props.onChange(nextRangeStr, e);
            }
        };
        _this.onFocus = function () {
            _this.setState({
                isFocus: true,
            });
        };
        _this.onBlur = function () {
            _this.setState({
                isFocus: false,
            });
        };
        _this.onMouseEnter = function () {
            _this.setState({
                allowClear: true,
            });
        };
        _this.onMouseLeave = function () {
            _this.setState({
                allowClear: false,
            });
        };
        _this.clearText = function () {
            _this.timePickerOne.clearText();
            _this.timePickerTwo.clearText();
            _this.setState({
                selectedRangeStr: ['', ''],
            });
        };
        var defaultValue = _this.props.defaultValue;
        var initRangeStr = ['', ''];
        if (defaultValue) {
            initRangeStr[0] = defaultValue[0];
            initRangeStr[1] = defaultValue[1];
        }
        _this.state = {
            selectedRangeStr: initRangeStr,
            allowClear: false,
            isFocus: false,
        };
        return _this;
    }
    RangeTimePicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps && nextProps.value) {
            this.setState({
                selectedRangeStr: [nextProps.value[0], nextProps.value[1]],
            });
        }
    };
    RangeTimePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, format = _a.format, placeholder = _a.placeholder, disabled = _a.disabled, defaultValue = _a.defaultValue, value = _a.value, onBeforeChange = _a.onBeforeChange, onChange = _a.onChange, rest = __rest(_a, ["format", "placeholder", "disabled", "defaultValue", "value", "onBeforeChange", "onChange"]);
        var _b = this.state, allowClear = _b.allowClear, selectedRangeStr = _b.selectedRangeStr, isFocus = _b.isFocus;
        var rangeCls = [
            'relative',
            'w-px-220',
            'inline-flex',
            'items-center',
            'justify-between',
            'px-px-12',
            'rounded',
            'text-sm',
            'border',
        ];
        var svgBoxCls = ['inline-flex', 'w-4', 'fill-black', , 'opacity-20'];
        if (isFocus)
            rangeCls.push('border-brand-600', 'shadow-input');
        if (disabled) {
            rangeCls.push('bg-gray-100', 'cursor-not-allowed');
        }
        else {
            rangeCls.push('bg-white');
            if (!isFocus) {
                rangeCls.push('hover:border-brand-600');
            }
        }
        return (React.createElement(DivTag, __assign({ name: RangeTimePicker.NAME, atomics: rangeCls, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave }, rest),
            React.createElement(TimePicker, { bordered: false, showIcon: false, format: format, placeholder: placeholder[0], disabled: disabled, value: selectedRangeStr[0], model: 'range', onChange: function (time, e) { return _this.timeItemChange(e, time, 0); }, onFocus: this.onFocus, onBlur: this.onBlur, ref: function (c) {
                    _this.timePickerOne = c;
                } }),
            React.createElement(SpanTag, null, "~"),
            React.createElement(TimePicker, { bordered: false, showIcon: false, format: format, placeholder: placeholder[1], disabled: disabled, value: selectedRangeStr[1], model: 'range', onChange: function (time, e) { return _this.timeItemChange(e, time, 1); }, onFocus: this.onFocus, onBlur: this.onBlur, ref: function (c) {
                    _this.timePickerTwo = c;
                } }),
            React.createElement(SpanTag, { atomics: svgBoxCls }, allowClear && selectedRangeStr[0] && selectedRangeStr[1] ? (React.createElement(WrongFilled, { className: 'w-4', onClick: this.clearText })) : null)));
    };
    RangeTimePicker.defaultProps = defaultRangeProps;
    RangeTimePicker.NAME = 'range-time-picker';
    RangeTimePicker.displayName = 'RangeTimePicker';
    return RangeTimePicker;
}(React.Component));
export { RangeTimePicker };
